import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import UserInputFlowTemplate from './UserInputFlowTemplate'
import { lang } from '../../assets/lang'

export default class UserInputFlowComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.USER_INPUT_FLOW)

    this.data.component = UserInputFlowTemplate
    this.socket = config ? config.sockets : null
  }

  builder (node) {
    node.lingualName = lingualName.USER_INPUT_FLOW
    this.setConnection()
    
    const userInputFlowInput = new Rete.Input(
      CONST_SOCKET.USER_INPUT_FLOW_INPUT, 
      lang.user_input_flow_socket_input_reply, 
      this.socket.userInputFlowInput, 
      true
    )

    const userInputFlowOuput = new Rete.Output(
      CONST_SOCKET.USER_INPUT_FLOW_OUTPUT, 
      lang.user_input_flow_socket_input_questions, 
      this.socket.userInputFlowOutput, 
      false
    )

    return node
      .addInput(userInputFlowInput)
      .addOutput(userInputFlowOuput)
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    // Do nothing for now
  }

  setConnection() {
    // UserInputFlow may take connection from:
    this.socket.userInputFlowInput.combineWith(this.socket.referenceOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.newPostbackOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.textOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.carouselOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.facebookMediaOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.imageOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.videoOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.audioOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.fileOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.ecommerceOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.genericTemplateOutput)
    this.socket.userInputFlowInput.combineWith(this.socket.otnOutput)
    
    // UserInputFlow may be connected to:
    this.socket.userInputFlowOutput.combineWith(this.socket.userInputFlowSingleInput)    
  }
}